import React from 'react';

function Academics() {
  // List of all departments from the college website
  const departments = [
    { name: 'ANAESTHESIOLOGY', icon: 'fa-syringe' },
    { name: 'ANATOMY', icon: 'fa-child' },
    { name: 'BIOCHEMISTRY', icon: 'fa-flask' },
    { name: 'COMMUNITY MEDICINE', icon: 'fa-users' },
    { name: 'DENTISTRY', icon: 'fa-tooth' },
    { name: 'DERMATOLOGY', icon: 'fa-allergies' },
    { name: 'FORENSIC MEDICINE', icon: 'fa-search' },
    { name: 'EMERGENCY MEDICINE', icon: 'fa-ambulance' },
    { name: 'ENT', icon: 'fa-deaf' },
    { name: 'GENERAL MEDICINE', icon: 'fa-stethoscope' },
    { name: 'GENERAL SURGERY', icon: 'fa-procedures' },
    { name: 'HOSPITAL ADMINISTRATION', icon: 'fa-hospital-alt' },
    { name: 'MICROBIOLOGY', icon: 'fa-microscope' },
    { name: 'NEUROLOGY', icon: 'fa-brain' },
    { name: 'NEUROSURGERY', icon: 'fa-brain' },
    { name: 'OBSTETRICS & GYNAECOLOGY', icon: 'fa-baby' },
    { name: 'OPHTHALMOLOGY', icon: 'fa-eye' },
    { name: 'ORTHOPAEDICS', icon: 'fa-bone' },
    { name: 'PAEDIATRICS', icon: 'fa-baby-carriage' },
    { name: 'PATHOLOGY', icon: 'fa-vial' },
    { name: 'PHARMACOLOGY', icon: 'fa-pills' },
    { name: 'PHYSIOLOGY', icon: 'fa-heartbeat' },
    { name: 'PSYCHIATRY', icon: 'fa-brain' },
    { name: 'PULMONARY MEDICINE', icon: 'fa-lungs' },
    { name: 'RADIO DIAGNOSIS', icon: 'fa-x-ray' },
    { name: 'UROLOGY', icon: 'fa-kidneys' }
  ];

  return (
    <div className="academics-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <h1 className="text-center mb-0">Academic Programs</h1>
        </div>
      </div>
      
      {/* Programs Section */}
      <section className="programs-section" style={{ padding: 'var(--spacing-xxxl) 0' }}>
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="section-title text-center">Our Programs</h2>
              <p className="lead">A.C. Subba Reddy Government Medical College offers quality medical education programs with modern infrastructure and experienced faculty.</p>
            </div>
          </div>
          
          <div className="row mb-5">
            {/* MBBS Program Card */}
            <div className="col-md-6 mb-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: 'var(--border-radius-md)', transition: 'var(--transition)' }}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-circle bg-primary-light me-3">
                      <i className="fas fa-user-md text-primary"></i>
                    </div>
                    <h3 className="card-title mb-0" style={{ color: 'var(--primary-color)', fontSize: 'var(--font-size-xl)' }}>MBBS Program</h3>
                  </div>
                  <p>Our MBBS program provides comprehensive medical education combining theoretical knowledge with extensive clinical exposure at our 1050-bed teaching hospital.</p>
                  <ul className="list-group list-group-flush mt-3">
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Duration:</strong> 5.5 years (4.5 years + 1 year internship)</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Seats:</strong> 175 MBBS seats per year</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Recognition:</strong> National Medical Commission</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Affiliation:</strong> Dr. NTR University of Health Sciences</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            
            {/* Postgraduate Programs Card */}
            <div className="col-md-6 mb-4">
              <div className="card shadow-sm h-100" style={{ borderRadius: 'var(--border-radius-md)', transition: 'var(--transition)' }}>
                <div className="card-body">
                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-circle bg-primary-light me-3">
                      <i className="fas fa-graduation-cap text-primary"></i>
                    </div>
                    <h3 className="card-title mb-0" style={{ color: 'var(--primary-color)', fontSize: 'var(--font-size-xl)' }}>Postgraduate Programs</h3>
                  </div>
                  <p>Since 2022, the college has begun offering postgraduate programs in various specialties, providing advanced training and research opportunities.</p>
                  <ul className="list-group list-group-flush mt-3">
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>MD/MS Programs</strong> in select specialties</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Duration:</strong> 3 years</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Started in:</strong> 2022</span>
                    </li>
                    <li className="list-group-item d-flex align-items-center">
                      <i className="fas fa-check-circle me-2" style={{ color: 'var(--success)' }}></i>
                      <span><strong>Recognition:</strong> National Medical Commission</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          {/* Departments Section */}
          <div className="row">
            <div className="col-12 mb-5">
              <h2 className="section-title text-center">Our Departments</h2>
              <p className="text-center lead mb-5">A.C. Subba Reddy Government Medical College features specialized departments providing comprehensive medical education and healthcare services.</p>
            </div>
          </div>
          
          <div className="row g-4 departments-grid">
            {departments.map((dept, index) => (
              <div className="col-6 col-md-4 col-lg-3" key={index}>
                <div className="department-card">
                  <div className="department-icon">
                    <i className={`fas ${dept.icon}`}></i>
                  </div>
                  <h5 className="department-name">{dept.name}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Research Section */}
      <section className="research-section" style={{ backgroundColor: 'var(--bg-gray)', padding: 'var(--spacing-xxxl) 0' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h2 className="section-title">Research Opportunities</h2>
              <p>Our institution is committed to advancing medical knowledge through rigorous research. We provide students and faculty with opportunities to engage in meaningful research projects that contribute to healthcare innovation.</p>
              <ul className="check-list">
                <li><i className="fas fa-check-circle"></i> State-of-the-art research facilities</li>
                <li><i className="fas fa-check-circle"></i> Collaboration with national and international institutions</li>
                <li><i className="fas fa-check-circle"></i> Regular scientific publications and conferences</li>
                <li><i className="fas fa-check-circle"></i> Research mentorship programs</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-4">
                  <h4 className="mb-4" style={{ color: 'var(--primary-color)', fontWeight: 'var(--font-weight-bold)' }}>Research Areas</h4>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="research-icon me-3">
                          <i className="fas fa-dna"></i>
                        </div>
                        <div>Clinical Research</div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="research-icon me-3">
                          <i className="fas fa-microscope"></i>
                        </div>
                        <div>Laboratory Sciences</div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="research-icon me-3">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <div>Epidemiology</div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="d-flex align-items-center">
                        <div className="research-icon me-3">
                          <i className="fas fa-heartbeat"></i>
                        </div>
                        <div>Public Health</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Academics;
